import React, { useState } from "react";
import axios from "axios";
import { Day } from "react-big-calendar";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem("token"); // Pobierz token z localStorage

const AddKarnetModal = ({ userId, onClose, onKarnetAdded }) => {
  const [form, setForm] = useState({
    nazwa: "",
    rodzaj: "Solo EMS",
    data_rozpoczecia: "",
    ilosc_miesiecy: 1,
    ilosc_wejsc: 10,
    ilosc_wejsc_kal: 10,
    platnosc_rodzaj: "calosc",
    ilosc_rat: 0,
    przypomnienie_platnosc: 4,
    ilosc_gwiazdek: 0,
    max_gwiazdek: 4,
    karnet_oplacone: 0,
    cena: 100,
    notatka: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => {
      const updatedForm = { ...prevForm, [name]: value };

      // Jeśli ilosc_wejsc jest zmieniona, zaktualizuj ilosc_wejsc_kal
      if (name === "ilosc_wejsc") {
        updatedForm.ilosc_wejsc_kal = value;
      }

      return updatedForm;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const karnetData = {
        userId,
        ...form,
      };

      // Set karnet_oplacone to cena if the payment type is "całość"
      if (form.platnosc_rodzaj === "calosc") {
        karnetData.karnet_oplacone = form.cena;
      }

      // Make the API call to create the karnet
      const response = await axios.post(
        `${BACKEND_URL}/api/karnet/addKarnetToUser`,
        karnetData,
        {headers: {
          Authorization: `Bearer ${token}`
        }}
      );

      // Extract the karnet_id from the response
      const karnetId = response.data.karnet_id || response.data._id;

      if (form.platnosc_rodzaj === "calosc") {
        // Add payment record
        const paymentData = {
          uzytkownik_id: userId,
          karnet_id: karnetId, // Use the extracted karnet_id
          kwota: parseFloat(form.cena),
          data_platnosci: new Date().toISOString().split("T")[0], // Today's date
          notatka: "",
        };

        await axios.post(`${BACKEND_URL}/api/payment/addPayment`, paymentData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      }

      alert("Karnet został utworzony pomyślnie!");
      onKarnetAdded(response.data);
      onClose();
    } catch (error) {
      console.error(error);
      alert("Błąd podczas tworzenia karnetu");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">
            Dodaj nowy karnet
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Nazwa karnetu */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nazwa karnetu
              </label>
              <input
                type="text"
                name="nazwa"
                value={form.nazwa}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Nazwa karnetu"
              />
            </div>

            {/* Rodzaj karnetu */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Rodzaj karnetu
              </label>
              <select
                name="rodzaj"
                value={form.rodzaj}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="Solo EMS">Solo EMS</option>
                <option value="Para EMS">Para EMS</option>
                <option value="Para Personalny">Para Personalny</option>
                <option value="Solo Personalny">Solo Personalny</option>
                <option value="Hybryda">Hybryda</option>
              </select>
            </div>

            {/* Data rozpoczęcia */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Data rozpoczęcia
              </label>
              <input
                type="date"
                name="data_rozpoczecia"
                value={form.data_rozpoczecia}
                onChange={handleChange}
                required
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Ilość miesięcy */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Ilość miesięcy
              </label>
              <input
                type="number"
                name="ilosc_miesiecy"
                value={form.ilosc_miesiecy}
                onChange={handleChange}
                required
                min="1"
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Ilość wejść */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Ilość wejść
              </label>
              <input
                type="number"
                name="ilosc_wejsc"
                value={form.ilosc_wejsc}
                onChange={handleChange}
                required
                min="1"
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Rodzaj płatności */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Rodzaj płatności
              </label>
              <select
                name="platnosc_rodzaj"
                value={form.platnosc_rodzaj}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="calosc">Całość</option>
                <option value="rata">Raty</option>
              </select>
            </div>

            {/* Ilość rat (widoczne tylko gdy wybrano raty) */}
            {form.platnosc_rodzaj === "rata" && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Ilość rat
                </label>
                <input
                  type="number"
                  name="ilosc_rat"
                  value={form.ilosc_rat}
                  onChange={handleChange}
                  required
                  min="2"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            )}

            {form.platnosc_rodzaj === "rata" && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Przypomnienie o płatności (ilość treningów)
                </label>
                <input
                  type="number"
                  name="przypomnienie_platnosc"
                  value={form.przypomnienie_platnosc}
                  onChange={handleChange}
                  required
                  min="1"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            )}

            {/* Maksymalna ilość gwiazdek */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Maksymalna ilość gwiazdek
              </label>
              <input
                type="number"
                name="max_gwiazdek"
                value={form.max_gwiazdek}
                onChange={handleChange}
                required
                min="0"
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Cena */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Cena (PLN)
              </label>
              <input
                type="number"
                name="cena"
                value={form.cena}
                onChange={handleChange}
                required
                min="0"
                step="0.01"
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Notatka */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Notatka
              </label>
              <textarea
                name="notatka"
                value={form.notatka}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Wprowadź notatkę"
              />
            </div>
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Anuluj
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition-colors"
            >
              Dodaj karnet
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddKarnetModal;
